"use client";
import type { ReactElement } from "react";
import { DIMMED_OPACITY } from "./gantt-constants";
import { selectTaskInteractionState } from "./gantt-render-selectors";
import type { GanttLayout } from "./gantt-types";
export interface GanttHoverRowLayerProps {
    ganttIdPrefix: string;
    layout: GanttLayout;
    hoveredTaskId: string | null;
    highlightedTaskIds: ReadonlySet<string>;
}
export function GanttHoverRowLayer({ ganttIdPrefix, layout, hoveredTaskId, highlightedTaskIds, }: GanttHoverRowLayerProps): ReactElement {
    return (<>
      {layout.taskRows.map((taskRow) => {
            const taskLayout = layout.taskLayoutById.get(taskRow.taskId);
            if (!taskLayout) {
                return null;
            }
            const interactionState = selectTaskInteractionState({
                taskId: taskLayout.task.id,
                hoveredTaskId,
                highlightedTaskIds,
            });
            if (!interactionState.isHovered) {
                return null;
            }
            return (<rect key={`${ganttIdPrefix}-task-hover-row-${taskLayout.task.id}`} x={0} y={taskRow.y} width={layout.timelineWidth} height={taskRow.height} fill="rgba(255,255,255,0.06)" opacity={interactionState.isDimmed ? DIMMED_OPACITY : 1}/>);
        })}
    </>);
}
